import BulletList from '@tiptap/extension-bullet-list';

export default BulletList.extend({
    addAttributes() {
        return {
            ...this.parent?.(),
            style: {
                default: null,
            },
            class: {
                default: null,
            },
            id: {
                default: null,
            },
        };
    },
});
